import React, { Component } from "react"
import PropTypes from "prop-types"
import Link from "gatsby-link"
import Helmet from "react-helmet"
//import WebFont from "webfontloader"
import { colors } from "./../constants"
import { Logo, Twitter, Design, Share, Code } from "./../lib/icons"
import "./index.css"
import "./header.css"

class Header extends Component {
  componentDidMount = () => {
    /*
    WebFont.load({
      typekit: {
        id: "kvh0bcc"
      }
    })
    */
    ;(function(d) {
      var config = {
          kitId: "kvh0bcc",
          scriptTimeout: 3000,
          async: true
        },
        h = d.documentElement,
        t = setTimeout(function() {
          h.className = h.className.replace(/\bwf-loading\b/g, "") + " wf-inactive"
        }, config.scriptTimeout),
        tk = d.createElement("script"),
        f = false,
        s = d.getElementsByTagName("script")[0],
        a
      h.className += " wf-loading"
      tk.src = "https://use.typekit.net/" + config.kitId + ".js"
      tk.async = true
      tk.onload = tk.onreadystatechange = function() {
        a = this.readyState
        if (f || (a && a != "complete" && a != "loaded")) return
        f = true
        clearTimeout(t)
        try {
          Typekit.load(config)
        } catch (e) {}
      }
      s.parentNode.insertBefore(tk, s)
    })(document)
  }
  render() {
    return null
    return (
      <div className="site-header">
        <div
          style={{
            paddingTop: 15,
            display: "flex",
            justifyContent: "space-between"
          }}
          className="content-wrapper"
        >
          <h4 style={{ margin: 0 }}>
            <Link to="/" style={{ fontSize: 20, marginTop: 4, letterSpacing: 0.3 }}>
              <Logo className="site-logo header-icon" />
            </Link>
          </h4>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <a
              href="https://twitter.com/reactdesigner"
              target="_blank"
              style={{ cursor: "pointer" }}
            >
              <Twitter
                className="header-icon"
                style={{ width: 12, position: "relative", top: 2, marginRight: 7, opacity: 0.5 }}
              />
              <span style={{ textDecoration: "underline" }}>@reactdesigner</span>
            </a>
            {/*
            <Link to="/apps">Apps</Link>
            <Link to="/learn">Learn</Link>
            <a className="headerButton" href="https://app.reactdesigner.com">
              Sign Up Free
            </a>
            */}
          </div>
        </div>
      </div>
    )
  }
}

class Footer extends Component {
  render() {
    return null
    return (
      <div className="site-footer">
        <div className="content-wrapper">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            {/*
            <div>
              <p style={{ fontWeight: 600 }}>Learn</p>
              <p>Reference</p>
              <p>Samples</p>
            </div>
            */}
            <div>
              <p style={{ fontWeight: 600 }}>Social</p>
              <a href="https://twitter.com/reactdesigner">@reactdesigner</a>
              {/*<p style={{ fontWeight: 600 }}>Creator</p>*/}
            </div>
            <div>
              <p style={{ fontWeight: 600 }}>Contribute</p>
              <a href="https://github.com/reactdesigner/reactdesigner">React Designer on GitHub</a>
              <a href="https://github.com/reactdesigner/reactdesigner/issues">GitHub Issues</a>
            </div>
            {/*
            <div>
              <p style={{ fontWeight: 600 }}>Support</p>
              <p>support@reactdesigner.com</p>
            </div>
            */}
          </div>
        </div>
      </div>
    )
  }
}

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      bodyAttributes={{ class: "" }}
      title="React Designer | Prototype visually, then export to React."
      meta={[{ name: "description", content: "A prototyping tool that exports real code." }]}
    >
      <link rel="icon" type="image/png" href="favicon.png" />
      <link href="https://static.reactdesigner.com/editor.css" rel="stylesheet" />

      {/* prettier-ignore  */}
      <script src="https://static.reactdesigner.com/editor.js"></script>
    </Helmet>
    <Header />
    <h1 style={{ paddingTop: 150, textAlign: "center" }}>Coming Soon</h1>
    {/*children()*/}
    <Footer />
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js